import { useFormik } from 'formik';

import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { schema } from '../lib';

import type { ReceiverInfo } from '../types';

import { setDeliveryReceiverInfo } from './actions';

type AddReceiverInfoProps = {
  initialValues: ReceiverInfo;
};

const useAddReceiverInfo = ({ initialValues }: AddReceiverInfoProps) => {
  const dispatch = useDispatch();

  const [isValid, setIsValid] = useState(false);

  const form = useFormik<ReceiverInfo>({
    initialValues,

    validationSchema: schema,
    validateOnMount: true,

    onSubmit: (values, { setSubmitting }) => {
      dispatch(
        setDeliveryReceiverInfo({
          ...values,
          firstName: values.firstName.trim(),
          lastName: values.lastName.trim(),
          additionalInfo: values.additionalInfo.trim()
        })
      );

      setSubmitting(false);
    }
  });

  const onGoBack = () => {
    dispatch(setDeliveryReceiverInfo.reset());
  };

  const checkIsValid = async () => {
    const isValid = await form.validateForm(form.values);
  };

  useEffect(() => {
    checkIsValid();

    if (!form.isValid) {
      setIsValid(false);

      return;
    }

    setIsValid(true);
  }, [form.isValid]);

  useEffect(() => {
    checkIsValid();
  }, [form.dirty]);

  return {
    form,
    isValid,
    onGoBack
  };
};

export { useAddReceiverInfo };
